
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/[param]/[month]/[day]",
      function () {
        return require("private-next-pages/sitemap/[param]/[month]/[day].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/[param]/[month]/[day]"])
      });
    }
  